import React from 'react';
import { ThemeProvider, lightTheme } from '@comfama/comfama-ui';
import './src/styles/global.css';

// TODO add dark theme support
export const wrapPageElement = ({ element }) => (
    <ThemeProvider customDarkTheme={lightTheme}>{element}</ThemeProvider>
);
